import type { TelephonyAutoRepairResult, TelephonyAutoRepairStep } from './types';

type PresentationTone = 'success' | 'danger' | 'muted';

export function telephonyRecoveryAvailability(activeCalls: number, activeChannels: number) {
  const blocked = Number(activeCalls || 0) > 0 || Number(activeChannels || 0) > 0;
  return {
    blocked,
    message: blocked
      ? 'Восстановление станет доступно после завершения активного звонка.'
      : '',
  };
}

const STEP_LABELS: Record<TelephonyAutoRepairStep['code'], string> = {
  PRECHECK: 'Проверка безопасности',
  PBX_PROVISION: 'Конфигурация и регистрация',
  STALE_CALLS: 'Зависшие состояния звонков',
  VERIFY: 'Итоговая проверка',
};

function stepPresentation(step: TelephonyAutoRepairStep) {
  const status = step.status === 'OK'
    ? { statusLabel: 'Готово', tone: 'success' as const }
    : step.status === 'SKIPPED'
      ? { statusLabel: 'Не требовалось', tone: 'muted' as const }
      : { statusLabel: 'Ошибка', tone: 'danger' as const };
  return {
    code: step.code,
    label: STEP_LABELS[step.code],
    message: step.message,
    ...status,
  };
}

export function telephonyRecoveryPresentation(result: TelephonyAutoRepairResult): {
  title: string;
  statusLabel: string;
  tone: PresentationTone;
  message: string;
  steps: ReturnType<typeof stepPresentation>[];
} {
  const verdict = result.status === 'HEALTHY'
    ? { title: 'Телефония исправна', statusLabel: 'Проверено', tone: 'success' as const }
    : result.status === 'REPAIRED'
      ? { title: 'Телефония восстановлена', statusLabel: 'Исправлено', tone: 'success' as const }
      : { title: 'Восстановление не завершено', statusLabel: 'Требует внимания', tone: 'danger' as const };
  return {
    ...verdict,
    message: result.message,
    steps: result.steps.map(stepPresentation),
  };
}
